import Vue from 'vue'
import EditorElementMenuList from '../components/EditorElementMenuList'
export default Vue.extend({
  props: {
    parent: {
      type: Object,
      required: true
    },
  },
  components: {
    EditorElementMenuList,
  },
  data() {
    return {
      open: 'style',
      positionClasses: [],
    }
  },
  created()  {
    this.loadElementProperties()
  },
  mounted() {
    if (! this.$refs.menu) {
      return
    }
    let observer = new IntersectionObserver(() => {
      let elementPosition = this.$refs.menu.getBoundingClientRect()
      this.positionClasses = elementPosition.height + elementPosition.y > window.innerHeight ? ['wf-bottom-0', 'wf-mb-8'] : []
    });
    observer.observe(this.$refs.menu)
  },
  computed: {
    elementProperties() {
      let array = []
      Object.keys(this.parent.properties).forEach(property => array.push(...this.parent.properties[property]))
      array = array.map(property => property.component)
      return array
    },
    module() {
      return this.parent.module
    },
    element() {
      return this.parent.element
    },
    family() {
      return this.parent.family
    },
    id() {
      return this.parent.id
    },
  },
  methods: {
    loadElementProperties() {
      this.elementProperties
        .forEach(property => this.$set(this.$options.components, property, () => import(`../MenuProperties/${property}.vue`)))
    },
    updateOpen(open) {
      this.open = open
    },
    menuClasses(item) {
      let classes = ['wf-p-2', 'wf-flex', 'wf-bg-white', 'wf-justify-between', 'wf-w-full', 'wf-items-center', 'hover:wf-text-blue-500', 'focus:wf-outline-none']
      if (item == this.open) {
        classes.push('wf-text-blue-500')
      }
      return classes
    },
  }
})